import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { Attribute } from '../../models/attribute.model'
import { BaseRepository, ListRequest, ListResponse } from '../base.repository'

export type SetAddressAttributesResponse = {
  referenceId: string
  results: {
    fieldName: string
    isResolved: boolean
    resolvedValue: string | number | boolean | null
    errorMessage: null | string
  }[]
  timestamp: string
  pullRequestId: string
  allConflictsResolved: boolean
}

@Injectable({
  providedIn: 'root',
})
export class AttributeRepository extends BaseRepository<Attribute> {
  public constructor() {
    super({
      resourceName: 'attributes',
      defaultSorting: [{ property: 'createdAt', direction: 'asc' }],
    })
  }

  public getAddressAttributes(
    addressId: string,
    listRequest?: ListRequest
  ): Observable<ListResponse<Attribute>> {
    return this.http.get<ListResponse<Attribute>>(
      `${this.baseUrl}/addresses/${addressId}/attributes`,
      {
        params: this.getHttpOptionsFromListRequest(listRequest),
      }
    )
  }

  public setAddressAttributes(
    addressId: string,
    attributes: { key: string; conflictId?: string }[]
  ): Observable<SetAddressAttributesResponse> {
    return this.http
      .post<SetAddressAttributesResponse>(
        `${this.baseUrl}/addresses/${addressId}/attributes`,
        { attributes }
      )
      .pipe()
  }
}
